<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVoorkoming">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseVoorkoming" aria-expanded="false" aria-controls="collapseVoorkoming">
                Voorkoming dubbele schenkbelasting
            </button>
        </h2>
        <div id="collapseVoorkoming" class="accordion-collapse collapse" aria-labelledby="headingVoorkoming"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als een schenking in meerdere landen belast is, kan dubbele heffing ontstaan. Nederland kent in de
                Successiewet een regeling om dubbele belasting te voorkomen. Daarbij kan vermindering worden verleend
                voor belasting die in het buitenland is betaald over dezelfde schenking. Dit vereist een onderbouwd
                verzoek, onder andere met bewijsstukken van betaling en een correcte berekening van het buitenlandse
                heffingsrecht.
                <div class="space20"></div>
                Nederland heeft met sommige landen verdragen of unilaterale afspraken hierover, maar niet
                met alle. Fiscale coördinatie tussen adviseurs in beide landen is cruciaal.
            </div>
        </div>
    </div>
</div>

